import { useState, useRef, useEffect, useMemo, useCallback, forwardRef, useImperativeHandle } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import SearchArea from "./area/search";
import ListFunc from "./func/list_func";

const StuSearchList = forwardRef((props: any, ref) => {
  const myProps = {
    list: (inData: any) => { },
    set_content_tab: (inData: any) => { },
    ...props
  };
  let user=useSelector((state:any) => state.user);
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_grade: ["student"],
    "s_class_seq": "",
    "s_stu_grade": "",
    "s_stu_state": "now",
    s_seq: [],
    select_stu_seq: "",
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    s_addon_study_use:"1",
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  useEffect(() => {

  }, []);

  const list = (inOptObj: any) => {
    let tmpListOpt = {
      ...listOpt,
      ...inOptObj
    };
    tmpListOpt["sc"] = listAggridRef.current.getListSc();
    setListOpt(tmpListOpt);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmpListOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = ListFunc.get_list_info_arr({ info_arr: response.data["data"]["info_arr"] });
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (listAggridRef.current) {
            listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
            //select_stu_seq
            if (!strFunc.is_empty(inOptObj["select_stu_seq"])) {
              setTimeout(() => {
                let listNodes = listAggridRef.current.getNodeRows();
                for (let i = 0; i < listNodes.length; i++) {
                  let node = listNodes[i];
                  if (inOptObj["select_stu_seq"] == node.data["a_seq"]) {
                    listNodes[i].setSelected(true);
                  } else {
                    listNodes[i].setSelected(false);
                  }
                }
              }, 100);
            }
          }
          onSelectionChanged({ 
            info_arr: response.data["data"]["info_arr"], 
            s_lecture_seq: tmpListOpt.s_stu_lecture_seq 
          });
        } else {

        }
      });
  };

  const setSelectFalseAll = () => {
    listAggridRef.current.setSelectFalseAll();
    onSelectionChanged({});
  };

  const cellClickedListener = (params: any) => {
    var key = params.colDef.field;
    if (key == "a_name") {

    }
  }

  const removeSelectStu = (stu_seq: any) => {
    let all_node_rows = listAggridRef.current.getNodeRows();
    for (let i = 0; i < all_node_rows.length; i++) {
      let tmp_seq = all_node_rows[i].data["a_seq"];
      if (tmp_seq == stu_seq) {
        all_node_rows[i].setSelected(false);
      }
    }
    setTimeout(() => {
      onSelectionChanged({});
    }, 100);
  };

  const set_height = (height: any) => {
    if (listAggridRef.current) {
      listAggridRef.current.setHeight(height);
    }
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    list, setSelectFalseAll, removeSelectStu, set_height
  }));


  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    if(key=="a_user_name"){
      render_str +=" "+params.data.a_stu_total_code;
    }else if (key == "row_view_manage") {

    } else if (key == "row_view_class_name") {
      if (params.data.class_arr) {
        let class_name_arr = [];
        for (let i = 0; i < params.data.class_arr.length; i++) {
          class_name_arr.push(params.data.class_arr[i]["class_name"]);
        }
        render_str = class_name_arr.join(" / ");;
      }
    } else if (key == "row_view_school_grade") {
      let row_grade_str = params.data.a_stu_grade;
      if (xColumnArr.select_arr.a_stu_grade) {
        for (let i = 0; i < xColumnArr.select_arr.a_stu_grade.length; i++) {
          if (xColumnArr.select_arr.a_stu_grade[i]["value"] == params.data.a_stu_grade) {
            row_grade_str = xColumnArr.select_arr.a_stu_grade[i]["text"];
          }
        }
      }
      let row_school_name = strFunc.cut_str(params.data.a_school_name, 2, "");
      render_str = row_school_name + " " + row_grade_str;
    }else if(key=="row_view_study_use"){
      render_str="";
      if(params.data.study_use_info_arr){
        render_str=params.data.study_use_info_arr.length;
      }
    }
    return render_str;
  }, []);

  const onSelectionChanged = (event: any) => {
    let opt_obj = {
      info_arr: infoArr,
      s_lecture_seq: listOpt.s_stu_lecture_seq,
      ...event
    };
    let selected_row = listAggridRef.current.getSelectedRows();
    let select_seq_arr = [];
    if (selected_row) {
      for (let i = 0; i < selected_row.length; i++) {
        select_seq_arr.push(selected_row[i]["a_seq"]);
      }
    }
    if (select_seq_arr.length == 0) {
      // selected_row = [...opt_obj.info_arr];
      // for (let i = 0; i < selected_row.length; i++) {
      //   select_seq_arr.push(selected_row[i]["a_seq"]);
      // }
    }

    myProps.list({
      "s_stu_user_seq": select_seq_arr,
      "s_stu_info_arr": selected_row,
      "s_lecture_seq": opt_obj.s_lecture_seq,
    });
  };

  return (
    <div>
      <SearchArea
        list={list}
        listOpt={listOpt}
        setListOpt={setListOpt}
        xColumnArr={xColumnArr}
        set_content_tab={myProps.set_content_tab}
      ></SearchArea>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: false,
          floatingFilter: false,
          rowMultiSelectWithClick: false,
          height: "60vh",
          onGridReady: () => {
            list({});
          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer,
          onSelectionChanged: onSelectionChanged
        }}
      ></ListAggrid>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
    </div>
  );
});

export default StuSearchList;
